module.exports = __webpack_public_path__ + "media/brands/ligier-6cc0492a.png";